import { render } from "./homeFooter.vue?vue&type=template&id=d2c1abfc&scoped=true"
const script = {}

import "./homeFooter.vue?vue&type=style&index=0&id=d2c1abfc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c1abfc"]])

export default __exports__